import Vue from 'vue';

export default {
    state: {
        sample: {},
    },
    mutations: {
        setSample(state, sample) {
            Vue.set(state, 'sample', { ...sample });
        },
        updateSample(state, sample) {
            state.sample = { ...sample };
        },
    },
    actions: {
        setSample({ commit }, sample) {
            commit('setSample', sample);
        },
        updateSample({ commit }, sample) {
            commit('updateSample', sample);
        },
    },
    getters: {
        getSample: state => state.sample,
    },
};
